
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.992 12.11a.988.988 0 000-1.405.999.999 0 00-1.41 0l-4.679 4.66c-3.42-3.067-7.918-4.958-12.878-4.958-10.618 0-19.257 8.602-19.257 19.174 0 4.929 1.89 9.419 4.98 12.823l-4.68 4.66a.988.988 0 00.71 1.692c.26 0 .51-.1.71-.288l4.68-4.66c3.419 3.067 7.918 4.958 12.877 4.958 10.619 0 19.257-8.602 19.257-19.175 0-4.928-1.89-9.418-4.979-12.823l4.67-4.659zM12.768 29.58c0-9.477 7.749-17.183 17.257-17.183 4.4 0 8.41 1.662 11.459 4.37L17.147 41.001c-2.71-3.047-4.379-7.039-4.379-11.42zm34.525 0c0 9.478-7.75 17.184-17.258 17.184-4.399 0-8.408-1.663-11.458-4.37l24.336-24.233c2.71 3.047 4.38 7.039 4.38 11.42z"}})])
          )
        }
      }
    